import request from "/@/utils/request";
import { AxiosResponse } from "axios";

const api = {
  login: "/console/login",
  getPlatformAuth: "/base/comm/getThirdPartyInit",
  loginOut: "/console/logout",
  getRefreshToken: "/base/comm/agentRefreshToken",
  getPortsNum: "/console/v1/clientUser/getPortInfo",
  updatePwd: "/base/comm/changeLoginPassword",
  updatRemark: "/base/comm/UpdateAccountRemark",
};

export interface loginParam {
  username: string;
  password: string;
}

export function login(
  param: loginParam
): Promise<AxiosResponse<IResponse<string>>> {
  return request({
    url: api.login,
    method: "post",
    data: param,
  });
}
export function getPlatformAuth(): Promise<AxiosResponse<IResponse<string>>> {
  return request({
    url: api.getPlatformAuth,
    method: "get",
  });
}
export function loginOut(): Promise<AxiosResponse<IResponse<string>>> {
  return request({
    url: api.loginOut,
    method: "post",
  });
}
export function refreshToken(): Promise<AxiosResponse<IResponse<string>>> {
  return request({
    url: api.getRefreshToken,
    method: "get",
  });
}

export function getPortsNum(): Promise<AxiosResponse<IResponse<string>>> {
  return request({
    url: api.getPortsNum,
    method: "get",
  });
}
const updatePwd = (param: any) => {
  return request({
    url: api.updatePwd,
    method: "post",
    data: param,
  });
};
const updatRemark = (param: any) => {
  return request({
    url: api.updatRemark,
    method: "post",
    data: param,
  });
};
export { updatePwd, updatRemark };
